import { render } from "./DeletAccountModal.vue?vue&type=template&id=0d636f30"
import script from "./DeletAccountModal.vue?vue&type=script&lang=js"
export * from "./DeletAccountModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__